//@flow
import React, { useState } from 'react';
import type { JobPost } from 'types/careers';
import { CardMetaInfo } from 'components/atoms/cardMetaInfo';
import { Image } from 'components/atoms/image';
import './styles.scss';

type Props = {
  data: Object<JobPost>,
  onClick: () => void,
};
export const JobPostGrid = (props: Props) => {
  const { data, onClick } = props;
  const [imageLoaded, setImageLoaded] = useState(false);

  const setOnload = () => {
    setImageLoaded(true);
  };

  return (
    <div className={'job-post-column'}>
      <div className={'post-grid'} onClick={() => onClick(data)}>
        <img
          className={'full'}
          onLoad={setOnload}
          style={
            data.thumbNailUrl && {
              animation: imageLoaded ? 'opacityAnimation 2000ms' : 'none',
            }
          }
          src={data.listImageUrl}
          alt={'job-post'}
        />
        {data.thumbNailUrl && (
          <img
            className={'thumb'}
            src={data.thumbNailUrl}
            alt={'job-post'}
            style={{
              visibility: imageLoaded ? 'hidden' : 'visible',
              position: 'absolute',
              // left: '0',
            }}
          />
        )}
        <CardMetaInfo
          data={{
            name: data.name,
            city: data.city,
            country: data.country,
            distance: data.distance,
          }}
          type={'jobs'}
        />
      </div>
    </div>
  );
};
